import { LandingLayout } from "../LandingLayout";
import { CallToAction } from "./components/CallToAction";
import { FAQ } from "./components/FAQ";
import { Hero } from "./components/Hero";
import { HowItWorks } from "./components/HowItWorks";
import { Stats } from "./components/Stats";
import { Testimonial } from "./components/Testimonial";

export default function Landing() {
  return (
    <LandingLayout>
      <Hero />
      <Stats />
      <Testimonial />
      <HowItWorks />
      <FAQ />
      <CallToAction />
    </LandingLayout>
  );
}
